import { render, staticRenderFns } from "./datasource-collect-minimization-status.vue?vue&type=template&id=3e00f5f2&scoped=true"
import script from "./datasource-collect-minimization-status.vue?vue&type=script&lang=js"
export * from "./datasource-collect-minimization-status.vue?vue&type=script&lang=js"
import style0 from "./datasource-collect-minimization-status.vue?vue&type=style&index=0&id=3e00f5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e00f5f2",
  null
  
)

export default component.exports